import { useState, useEffect, useCallback } from 'react';
import { Upload, FileText, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/lib/api';

const DOC_TYPES = ['Business license', 'Food establishment license', 'USDA inspection', 'Dairy license', 'Organic certification', 'Cottage food documentation', 'Insurance certificate', 'W-9', 'Product labels', 'Product photographs', 'Farm photographs', 'Wholesale price sheet', 'Other'];

export default function FarmDocuments() {
  const [docs, setDocs] = useState([]);
  const [docType, setDocType] = useState(DOC_TYPES[0]);
  const [uploading, setUploading] = useState(false);

  const load = useCallback(() => api.get('/farm/documents').then((r) => setDocs(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append('doc_type', docType); fd.append('file', file);
    try { await api.post('/farm/documents', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); toast.success('Uploaded securely'); load(); }
    catch { toast.error('Upload failed'); } finally { setUploading(false); e.target.value = ''; }
  };

  const del = async (id) => { await api.delete(`/farm/documents/${id}`); toast.success('Removed'); load(); };

  return (
    <div data-testid="farm-documents" className="max-w-3xl">
      <p className="font-manrope text-dark/60 mb-6">Your documents are stored securely and are never public unless FarmBox intentionally designates them so.</p>
      <div className="bg-white rounded-2xl p-6 md:p-8 border border-forest/10">
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          <select value={docType} onChange={(e) => setDocType(e.target.value)} className="bg-cream border border-forest/20 rounded-xl px-4 py-2.5 font-manrope" data-testid="doc-type-select">{DOC_TYPES.map((t) => <option key={t}>{t}</option>)}</select>
          <label className="btn-primary py-2.5 px-6 text-sm cursor-pointer" data-testid="doc-upload-btn"><Upload className="w-4 h-4 mr-2" />{uploading ? 'Uploading…' : 'Upload Document'}<input type="file" className="hidden" onChange={handleUpload} disabled={uploading} /></label>
        </div>
        <div className="space-y-2">
          {docs.length === 0 ? <p className="font-manrope text-dark/50">No documents uploaded yet.</p> : docs.map((d) => (
            <div key={d.file_id} className="flex items-center gap-3 p-3 bg-cream rounded-xl" data-testid={`doc-${d.file_id}`}>
              <FileText className="w-5 h-5 text-forest" />
              <div className="flex-1"><p className="font-manrope text-sm font-medium text-dark">{d.original_filename}</p><p className="font-manrope text-xs text-dark/50">{d.doc_type}</p></div>
              <button onClick={() => del(d.file_id)} className="p-2 hover:bg-red-50 rounded-lg"><Trash2 className="w-4 h-4 text-red-500" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
